var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4333 11.25L6.75833 7.575C6.46667 7.80833 6.13125 7.99306 5.75208 8.12917C5.37292 8.26528 4.96944 8.33333 4.54167 8.33333C3.48194 8.33333 2.58507 7.96632 1.85104 7.23229C1.11701 6.49826 0.75 5.60139 0.75 4.54167C0.75 3.48194 1.11701 2.58507 1.85104 1.85104C2.58507 1.11701 3.48194 0.75 4.54167 0.75C5.60139 0.75 6.49826 1.11701 7.23229 1.85104C7.96632 2.58507 8.33333 3.48194 8.33333 4.54167C8.33333 4.96944 8.26528 5.37292 8.12917 5.75208C7.99306 6.13125 7.80833 6.46667 7.575 6.75833L11.25 10.4333L10.4333 11.25ZM4.54167 7.16667C5.27083 7.16667 5.89062 6.91146 6.40104 6.40104C6.91146 5.89062 7.16667 5.27083 7.16667 4.54167C7.16667 3.8125 6.91146 3.19271 6.40104 2.68229C5.89062 2.17188 5.27083 1.91667 4.54167 1.91667C3.8125 1.91667 3.19271 2.17188 2.68229 2.68229C2.17188 3.19271 1.91667 3.8125 1.91667 4.54167C1.91667 5.27083 2.17188 5.89062 2.68229 6.40104C3.19271 6.91146 3.8125 7.16667 4.54167 7.16667ZM3.08333 5.125V3.95833H6V5.125H3.08333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom_out.7d272e94.svg";
export { ForwardRef as ReactComponent };